module.exports = __webpack_public_path__ + "static/mural-2-591213ba1acf2604f953ad68bd232b08.jpg";